import { useEffect, useState } from "react";
import * as api from "./api";
import { errorText } from "../../inquiry/v6Api";
import { showToast } from "../../../utill/utill";
import { bizFmt, phoneFmt, kstFull, kstShort } from "../../inquiry/view";
import { ResTag, LangTag, ChTag } from "./Tags";
import { storeName } from "./logic";
import { useDismiss } from "../../v6common/a11y";

// 대화 전체 서랍(시안 openConv, 계약 §13 …/detail · …/inquiry)
function Notice({ d, meta }) {
    if (d.result === "escalated") {
        const q = d.inquiry;
        const st = q && ((meta?.statuses || []).find((s) => s.code === q.status)?.label || q.status);
        return (
            <div className="sec"><div className="ai" style={q ? undefined : { borderColor: "#f5c2c2", background: "#fff7f7" }}>
                <div className="ai-h" style={q ? undefined : { color: "var(--red)" }}><i className={`fa-solid ${q ? "fa-link" : "fa-triangle-exclamation"}`}></i>
                    {q ? `문의 No.${q.id}로 접수됨 · ${st}` : "상담 연결로 넘어갔는데 문의가 등록되지 않았습니다"}</div>
                <ul>{q ? <li>{q.request_content}</li> : <li>아래 [문의로 등록]을 누르면 대화 내용이 요청 내용으로 들어간 채 접수됩니다</li>}</ul>
            </div></div>
        );
    }
    if (d.result === "failed") {
        return (
            <div className="sec"><div className="ai" style={{ borderColor: "#f5c2c2", background: "#fff7f7" }}>
                <div className="ai-h" style={{ color: "var(--red)" }}><i className="fa-solid fa-circle-xmark"></i>챗봇이 답하지 못한 대화</div>
                <ul><li>지식베이스에 없는 내용입니다. 자주 나오면 지식베이스에 문서로 올리세요.</li></ul>
            </div></div>
        );
    }
    return null;
}

export default function ConvDrawer({ id, meta, refreshKey, onClose, onOpen, onChanged, onStoreExport, go }) {
    const [d, setD] = useState(null);
    const [msg, setMsg] = useState("");
    const dismiss = useDismiss(onClose);
    const [reload, setReload] = useState(0);
    const [busy, setBusy] = useState(false);

    useEffect(() => {
        let alive = true;
        setMsg("");
        api.getSessionDetail(id).then((r) => alive && setD(r)).catch((e) => alive && setMsg(errorText(e)));
        return () => { alive = false; };
    }, [id, reload, refreshKey]);

    if (!d || d.session_id !== id) {
        return (<><div className="dim on" {...dismiss}></div>
            <aside className="drawer on" aria-busy="true"><div className="dr-b"><div className="note">{msg || "불러오는 중…"}</div></div></aside></>);
    }

    async function makeInquiry() {
        setBusy(true);
        try {
            const r = await api.registerInquiry(id);
            showToast(`No.${r.id} ${r.store?.name || storeName(d)} 문의로 등록했습니다.`, "success");
            onChanged();
            setReload((n) => n + 1);
        } catch (e) {
            showToast(errorText(e), "error");
            if (e?.response?.status === 409) { onChanged(); setReload((n) => n + 1); }
        } finally {
            setBusy(false);
        }
    }

    const store = d.store;
    const recent = (d.recent_sessions || []).filter((x) => x.session_id !== d.session_id);
    const inqId = d.inquiry?.id ?? d.inquiry_id;
    const resp = d.first_response_sec != null ? `${Math.round(d.first_response_sec * 10) / 10}초` : "-";

    return (<>
        <div className="dim on" {...dismiss}></div>
        <aside className="drawer on">
            <div className="dr-h"><div className="dr-h-top">대화 {kstFull(d.started_at)} <LangTag lang={d.lang} /> <ChTag channel={d.channel} /> <ResTag result={d.result} />
                <button className="btn btn-ghost btn-sm x" onClick={onClose} aria-label="닫기"><i className="fa-solid fa-xmark"></i></button></div>
                <h3>{storeName(d)}</h3>
                <div className="dr-meta">
                    {store?.business_number && <span><i className="fa-regular fa-id-card"></i>{bizFmt(store.business_number)}</span>}
                    {store?.phone && <span><i className="fa-solid fa-phone"></i>{phoneFmt(store.phone)}</span>}
                    <span><i className="fa-solid fa-tag"></i>{d.quick_category?.name || "분류 없음"}</span>
                    <span><i className="fa-regular fa-clock"></i>{`첫 응답 ${resp} · ${d.turns}턴`}</span>
                    {d.requery && <span style={{ color: "#b45309" }}><i className="fa-solid fa-repeat"></i>같은 세션 재질문</span>}
                </div></div>
            <div className="dr-b">
                <Notice d={d} meta={meta} />
                <div className="sec"><div className="sec-t">대화 전체</div>
                    <div className="chat" style={{ maxHeight: "none" }}>
                        {(d.messages || []).map((m) => <div key={m.id} className={`bub ${m.role === "user" ? "u" : "b"}`}>{m.content}</div>)}
                    </div>
                </div>
                {store && (
                    <div className="sec"><div className="sec-t">이 매장의 최근 대화
                        {store.business_number && <button className="btn btn-sm" style={{ marginLeft: "auto" }} onClick={() => onStoreExport(store)}><i className="fa-solid fa-file-excel" style={{ color: "#15803d" }}></i>이 매장 대화 엑셀</button>}
                        {" "}<span className="hint">{recent.length}건</span></div>
                        <ul className="lst">
                            {recent.length ? recent.map((x) => (
                                <li key={x.session_id} onClick={() => onOpen(x.session_id)}><ResTag result={x.result} /><span className="q">{x.first_question || "(질문 없음)"}</span><span className="t">{kstShort(x.started_at)}</span></li>
                            )) : <li style={{ color: "var(--tx3)", cursor: "default" }}>없음</li>}
                        </ul></div>
                )}
            </div>
            <div className="dr-f">
                {inqId != null
                    ? <button className="btn btn-pri" onClick={() => go("inquiry", { openId: inqId })}><i className="fa-solid fa-clipboard-list"></i>문의 No.{inqId} 열기</button>
                    : d.result === "escalated" && <button className="btn btn-pri" disabled={busy} onClick={makeInquiry}><i className="fa-solid fa-plus"></i>문의로 등록</button>}
                <span className="sp"></span><button className="btn" onClick={onClose}>닫기</button>
            </div>
        </aside>
    </>);
}
